import React from 'react';
import { createUseStyles } from 'react-jss';

import { InputText } from 'primereact/inputtext';

function MzInputText({ options, optionLabel,placeholder,  stateValue, setStateValue, onChange, className, id, disabled }) {
    const st = styles();
  
    let [borderStyle, setBorderStyle] = React.useState({});
  
  
    React.useEffect(()=>{
  
    },[])
  
  
    const onInternalChange = e => {
      if(setStateValue)
        setStateValue(e.target.value);
     
    if (e.target.value)
      setBorderStyle({ borderColor: "var(--primary-color)" , borderWidth:"2px" })
    else
      setBorderStyle({})
  
      if (onChange)
        onChange(e);
    }
    
    return (
      <div className={"w-full "+st.container+ " "+className}>
       <InputText disabled={disabled} id={id} placeholder={placeholder}  className='w-full' style={borderStyle} value={stateValue} onChange={(e) => onInternalChange(e)} />
      </div>
    );
  }

const styles = createUseStyles({
  container: {}
});

export default MzInputText;